import '@/lib/faro';

// import 'shared/css';
import '@/assets/styles.css';
import '@/lib/sentry';
import '@/lib/azure';
import '@/lib/colord';

import {createRoot} from 'react-dom/client';
import {trackFaroRouter} from 'shared';

import {msal} from '@/lib/azure';
import {router} from '@/router/router';

import {AppProvider} from './providers/AppProvider';

const container = document.getElementById('root');
const root = createRoot(container!);

trackFaroRouter(router);

msal.initialize().then(() => {
  root.render(<AppProvider />);
});
